export const COOKIE_KEY = 'is-cookies-accepted';
export const COOKIE_VALUE = 'accepted';
export const COOKIE_EXPIRES = 1095;
